import gql from 'graphql-tag'
import DocumentsFragment from './DocumentsFragment'

const taxAddressFragment = `
  taxAddress {
    rid
    city
    state
    street
    zip
    apt
  }
`

export default gql`
  query DocumentsQuery($rid: Int!) {
    helloSign {
      testMode
      clientId
    }
    loan(rid: $rid, unscoped: true) {
      id
      rid
      lastTaxReturnOnOptions
      flowVariant
      multiproductFlow
      noTranscriptsFlow
      cre
      appNumber
      affiliates {
        rid
        name
        borrowerType
        taxReturnUrls {
          value
          label
        }
        documents {
          ${DocumentsFragment}
        }
        archivedDocuments {
          ${DocumentsFragment}
        }
      }
      businesses {
        rid
        name
        correctTaxFormId
        borrowerType
        ${taxAddressFragment}
        fiscalYears {
          rid
          year
          period
        }
        taxReturns {
          rid
          formName
          year
          firstName
          lastName
          tin
          secondFirstName
          secondLastName
          secondTin
          name
          formId
        }
        financial {
          fiscalYearEndOn
          lastTaxReturnOn
        }
        taxReturnUrls {
          value
          label
        }
        documents {
          ${DocumentsFragment}
        }
        archivedDocuments {
          ${DocumentsFragment}
        }
        guarantors {
          rid
          name
          email
          useBusinessTaxReturn
          orderId
          spouseId
          ${taxAddressFragment}
          fiscalYears {
            rid
            year
            period
          }
          taxReturns {
            rid
            formId
            formName
            year
          }
          taxReturnUrls {
            value
            label
          }
          business {
            rid
          }
          documents {
            ${DocumentsFragment}
          }
          archivedDocuments {
            ${DocumentsFragment}
          }
        }
        corporateGuarantors {
          rid
          name
          borrowerType
          documents {
            ${DocumentsFragment}
          }
          archivedDocuments {
            ${DocumentsFragment}
          }
        }
        seniorStaff {
          rid
          name
          documents {
            ${DocumentsFragment}
          }
        }
      }
      creditMemoAuthWarnings {
        rid
        name
        value
      }
    }
  }
`
